import styled from 'styled-components';
import { Text } from '../Text/Text';
export var StyledParagraph = /*#__PURE__*/styled(Text).withConfig({
  displayName: "StyledParagraph",
  componentId: "c11n-8-99-3__sc-e666if-0"
})([""]);